import React, { useEffect, useState } from 'react';
import { Menu } from 'primereact/menu';
import { useSelector, useDispatch } from 'react-redux';
import { CustomButton } from '../CustomButton';
import { ReactComponent as Filter } from '../../assets/svgIcons/filter-icon.svg';
import { InputText } from 'primereact/inputtext';
import { useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  changeForwardModalAgentSearchtUser,
  changeForwardModalTicketStatusFilter,
} from '../../reducers/wca/sales-support/sales-support-slice';

const Search = () => {
  const [username, setUsername] = useState('');
  const [err, setErr] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const dispatch = useDispatch();
  const { mob } = useParams();

  useEffect(() => {
    const debouncedSearch = setTimeout(() => {
      dispatch(changeForwardModalAgentSearchtUser(username));
    }, 1000);
    return () => {
      clearTimeout(debouncedSearch);
    };
  }, [username]);

  useEffect(() => {
    if (mob && mob?.length > 4) {
      setUsername(mob);
      dispatch(changeForwardModalAgentSearchtUser(mob));
    }
  }, [mob]);

  return (
    <div className="search w-full" style={{ background: 'white' }}>
      <div className="searchForm flex gap-2 align-items-center justify-content-center p-1">
        <div className="flex-grow-1">
          <span className="p-input-icon-right w-full">
            {!username || username?.length === 0 ? (
              <i className="pi pi-search " />
            ) : (
              <i
                className="pi pi-times cursor-pointer"
                onClick={() => {
                  setUsername('');
                }}
              />
            )}
            <InputText
              type="text"
              placeholder="Search customer"
              onChange={(e) => {
                setInitialLoad(false);
                setUsername(e.target.value);
              }}
              value={username}
              className="chat-search capitalize"
            />
          </span>
        </div>
      </div>
      {err && <span>Customer not found!</span>}
    </div>
  );
};

export default Search;
